/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { htmlspecialchars } from './util.js';

import { $ } from '../other/jquery-hooked.js';


var g_ti = null;

function _remove_tooltip( $tt_overlay_elem ) {
	if( g_ti===null ) g_ti = $(document).tooltip('instance');
	g_ti._removeTooltip($tt_overlay_elem);
}

function closeStaleTooltips() {
	// remove the older tooltip
	var tt;
	if( (tt=document.getElementsByClassName('ui-tooltip')).length > 1 ) _remove_tooltip( $(tt[0]) );
}

export function closeAllTooltips() {
	var tt, ml=0;
	while( (tt=document.getElementsByClassName('ui-tooltip')).length > 0 && ++ml < 100 ) _remove_tooltip( $(tt[0]) );
}


export function setupTooltips() {
	var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
	if( iOS ) return;
	/*** NOTE:
	 * have DISABLED liveRegion stuff directly in tooltips code in <jquery-ui-hooked>
	 *  thats crap and was not even configurable !?
	 ***/
	$(document)
		.tooltip(
			{
				items: '[title]:not(.no-tooltip,[disabled],iframe,.ui-slider-handle)',
				show: false,
				hide: false,
				track: false,
				open: function( ev, ui ) {
					// remove stale tooltips
					closeStaleTooltips();
				},
				close: function( ev, ui ) {
					if( ui.tooltip ) {
						// remove the dom nodes of the tooltips
						_remove_tooltip(ui.tooltip);
					}
				},
				content: function() {
					// support custom content (function or string) on nodes ...
					//var custom = $.data(this,'mj-custom-tooltip');		// <-- NOTE: this will NOT detect data-mj-custom-tooltip attributes
					var custom = $(this).data('mj-custom-tooltip');			// <-- NOTE: this will also detect data-mj-custom-tooltip attributes
					if( custom!=null ) {
						var custom_type = typeof custom;
						if( custom_type==='function' ) return custom.apply(this,arguments);
						if( custom_type!=='undefined' ) return custom;
					}
					// support: IE<9, Opera in jQuery <1.7
					// .text() can't accept undefined, so coerce to a string.
					// Escape title, since we're going from an attribute to raw HTML.
					// but first we remove complete html tags
					var title = this.title.replace(/<(.|\s)*?>/g,'');
					return htmlspecialchars(title||'',false,false);
				},
			}
		);
}




